const enum FilterType {
  RECOMMENDATIONS = 'RECOMMENDATIONS',
  ATTRIBUTES = 'ATTRIBUTES',
}

export default FilterType;
